'use client';

import { DynamicFormType } from '../type';
import SingleStepForm from './SingleStepForm';
import MultiStepForm from './multiStep/MultiStepForm';

type Props = {
  data: DynamicFormType;
};

const isMultiStep = (data: DynamicFormType) => {
  const { form } = data;
  return form?.formType !== 'single' && (form?.steps?.length ?? 0) > 1;
};

const DynamicForm = ({ data }: Props) => {
  if (isMultiStep(data)) {
    return <MultiStepForm data={data} />;
  }
  return <SingleStepForm data={data} />;
};

export default DynamicForm;
